/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-work-and-rest-template',
  templateUrl: './work-and-rest-template.component.html',
  styleUrls: ['./work-and-rest-template.component.scss'],
  standalone: false,
})
export class WorkAndRestTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
  @Input() buttonFunctions: { [key: string]: () => void };
}
